import { withStyles } from '@material-ui/styles';
import React, { useMemo } from 'react';

import checkNumberData from '../../../utils/checkNumberData';
import { createValueLabel, mapValue } from '../actions/dataActions';
import styles from '../styles/generalData';
import CustomTitle from './CustomTitle';
import Optional from '../../../utils/optional';
import { formatDateForDisplay } from '../../../utils/formatDate';
import { isDefined, isArray } from '../../../utils/isDefined';

const Product = ({ classes, product = {}, isOpen, onToggle }) => {
  const statusBoxColor = useMemo(() => {
    const status = Optional(product?.status).or('');
    switch (status) {
      case 'ACTIVE':
        return '#E8F5E9';
      case 'DISCONNECTED':
        return '#FDE9E9';
      default:
        return '#FDF3D5';
    }
  }, [product?.status]);

  return (
    <div className={classes.productRoot}>
      <CustomTitle
        isDataExist
        directTitle={product?.name}
        isOpen={isOpen}
        onToggle={onToggle}
        dotsMenu={true}
        menuComponent={
          <div
            className={classes.statusBox}
            style={{ backgroundColor: statusBoxColor }}
          >
            <div>{Optional(product?.status).or('')}</div>
          </div>
        }
      >
        <div>
          <div
            className={classes.dataContainer}
            style={{ backgroundColor: '#FAFAFA' }}
          >
            <div className={classes.productDataKey}>Name</div>
            <div>{Optional(product?.name).or('')}</div>
          </div>
          <div
            className={classes.dataContainer}
            style={{ backgroundColor: '#FFF' }}
          >
            <div className={classes.productDataKey}>Start date</div>
            <div>
              {Optional(product?.startDate)
                .map(date => formatDateForDisplay(date))
                .or('')}
            </div>
          </div>
          <div
            className={classes.dataContainer}
            style={{ backgroundColor: '#FAFAFA' }}
          >
            <div className={classes.productDataKey}>Status</div>
            <div>{Optional(product?.status).or('')}</div>
          </div>
          {isDefined(product?.terminationDate) && (
            <div
              className={classes.dataContainer}
              style={{ backgroundColor: '#FFF' }}
            >
              <div className={classes.productDataKey}>Termination date</div>
              <div>
                {Optional(product?.terminationDate)
                  .map(date => formatDateForDisplay(date))
                  .or('')}
              </div>
            </div>
          )}
          <div
            className={classes.dataContainer}
            style={{
              backgroundColor: isDefined(product?.terminationDate)
                ? '#FAFAFA'
                : '#FFF'
            }}
          >
            <div className={classes.productDataKey}>Offering</div>
            <div>{Optional(product?.productOffering?.name).or('')}</div>
          </div>
          <div
            className={classes.dataContainer}
            style={{
              backgroundColor: isDefined(product?.terminationDate)
                ? '#FFF'
                : '#FAFAFA'
            }}
          >
            <div className={classes.productDataKey}>Characteristics</div>
            <div>
              {isArray(product?.characteristic)
                ? product.characteristic.map((el, i) => {
                    return (
                      <div className={classes.characteristic} key={i}>{`${
                        el.name
                      }: ${el.displayValue ? el.displayValue[0] : ''}`}</div>
                    );
                  })
                : ''}
            </div>
          </div>
        </div>
      </CustomTitle>
    </div>
  );
};

export default withStyles(styles)(Product);
